<template> 
<b-form-group align="left">
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <label> Clinicas: </label> 
    <b-form-select v-model="clinica" v-if="!loading" >
        <b-form-select-option v-for="elemento in clinicas" :key="elemento.idClinica" :value="elemento.idClinica">{{ elemento.strNombre }}</b-form-select-option>
    </b-form-select>
    <b-spinner small v-if="loading"></b-spinner>
</b-form-group>
</template>

<script>
export default {
    name: "ClinicasActivas",
    props: { 
    },
    data: () => ({
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
        clinicas: [],
        clinica: null,
        loading: true,

    }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
    methods: {
        getObtenerClinicasActivas() {
            this.$http
                .post(this.$api + "catalogos/listaClinicasActivas", {})
                .then((response) => {
                    this.clinicas = response.data.data;
                })
                .catch((error) => {
                    console.error(error);
                }).finally(() =>   
                    this.loading = false
                );
                  
        },
    },
    mounted() {
        this.getObtenerClinicasActivas();
    }, 
}
</script>
